import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./assets/scss/mdb-free.scss";
import { AppContainer } from "./containers/App";
import { CampaignContainer } from "./containers/Campaign";
import { ErrorContainer } from "./containers/Error";
import { PointCardContainer } from "./containers/PointCard";
import { ShopContainer } from "./containers/Shops";
import { UserContainer } from "./containers/User";

ReactDOM.render(
  <Router>
    <AppContainer.Provider>
      <ErrorContainer.Provider>
        <UserContainer.Provider>
          <CampaignContainer.Provider>
            <PointCardContainer.Provider>
              <ShopContainer.Provider>
                <App />
              </ShopContainer.Provider>
            </PointCardContainer.Provider>
          </CampaignContainer.Provider>
        </UserContainer.Provider>
      </ErrorContainer.Provider>
    </AppContainer.Provider>
  </Router>,
  document.getElementById("root")
);
